var render = function render(_c,_vm){return _c('div',{staticClass:"base-icon-wrapper",class:{ 'base-icon-wrapper_variant_primary': _vm.props.variantPrimary }},[_vm._t("icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }